// @TODO yaCounter задается в index.html
const metrika = {
    reachGoal() {
        if (!window.yaCounter26539410) {
            return;
        }

        window.yaCounter26539410.reachGoal(...arguments);
    }
};

export {
    metrika,
}


// WEBPACK FOOTER //
// ./src/services/analytics/metrika.js